module.exports = __webpack_public_path__ + "img/14a-doc-acao-editar-rascunho.e7da65be.png";